<div class="relative min-h-screen h-full">
  <div style="padding-bottom: 8rem;">
    <ow-header></ow-header>
    <ow-order-steps></ow-order-steps>
    <div class="grid m-0">
      <div class="col-12 lg:col-8 p-4">
        <router-outlet></router-outlet>
      </div>
      <div class="col-12 lg:col-4 p-4">
        <ow-shopping-basket></ow-shopping-basket>
        <br />
        <ow-hotline-cta></ow-hotline-cta>
      </div>
    </div>
  </div>
  <div class="absolute bottom-0 w-full">
    <ow-footer></ow-footer>
  </div>
</div>
<p-toast></p-toast>